import { createContext, useEffect, useState } from 'react';

export const WindowSizeContext = createContext(0);

export function WindowSizeProvider({ children }) {
  const [windowWidth, setWindowSize] = useState<number>(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return <WindowSizeContext.Provider value={windowWidth}>{children}</WindowSizeContext.Provider>;
}
